module.exports = __webpack_public_path__ + "static/social_eval-2f5f5314200d5bbf9b889fe053fecce8.jpg";